export enum CustomValidatorErrorEnum {
    INVALID_EMAIL = 'invalidEmail',
    EMPTY_INPUT = 'emptyInput',
    FRONTEND_NOT_UNIQUE = 'frontendNotUnique',
    INVALID_PRIMER_SELECTED = 'invalidPrimerSelected',
    MAX_ARRAY_SIZE = 'maxArraySize',
    BARCODE_ALREADY_USED = 'barcodeAlreadyUsed',
    OUT_OF_STOCK_PRIMER_SELECTED = 'outOfStockPrimerSelected',
    EXPIRED_SAMPLE = 'expired-sample',
    CONTAMINATED_SAMPLE = 'contaminated-sample',
    TUBE_MISSING_SAMPLE = 'tubeMissing-sample',
    INVALID_BARCODE = 'invalid-barcode',
    DISPOSED_SAMPLE = 'disposed-sample',
    USED_BARCODE = 'used-barcode',
    SAMPLE_NOT_RECEIVED = 'sample-not-received',
    EMPTY_SAMPLE = 'empty-sample',
    NOT_UNIQUE = 'not-unique',
    BACKEND_INVALID = 'backend-invalid',
    PATTERN = 'pattern',
    STANDARD_PRIMER = 'standard-primer',
}
